import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Styles from './progress-bar-styles.scss';
import { FlagEnd, FlagStart } from '../icons';
const ProgressBar = ({ title = 'ProgressBar', backgroundColor = 'green', percentage = 0, percentageTitle = 'Progress' }) => {
    const [finalPercentage, setFinalPercentage] = useState(0);
    useEffect(() => {
        if (percentage >= 100) {
            setFinalPercentage(100);
        }
        else {
            setFinalPercentage(percentage);
        }
    }, [percentage]);
    return (React.createElement("div", { className: classNames(Styles.progressBarWrap, Styles[backgroundColor]) },
        React.createElement("div", { className: Styles.start },
            React.createElement("span", null),
            React.createElement(FlagStart, null)),
        React.createElement("div", { className: Styles.progress },
            React.createElement("div", { className: classNames(Styles.progressFill), style: { width: `${finalPercentage}%` } },
                React.createElement("div", { className: Styles.point },
                    finalPercentage !== 100 && finalPercentage >= 4 && (React.createElement("span", { className: Styles.circle, style: {
                            left: `${finalPercentage}%`
                        } })),
                    React.createElement("div", { className: Styles.tooltip },
                        percentageTitle,
                        ": ",
                        finalPercentage,
                        "%")))),
        React.createElement("div", { className: Styles.end },
            React.createElement("span", null),
            React.createElement(FlagEnd, null))));
};
export default ProgressBar;
